
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { TransactionTable } from "@/components/history/TransactionTable";
import { useTransactionData } from "@/hooks/useTransactionData";
import { Card } from "@/components/ui/card";
import { useState } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const Sold = () => {
  const [period, setPeriod] = useState("day");
  const { data = [], isLoading, refetch } = useTransactionData(period);

  return (
    <DashboardLayout userType="owner">
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-bold">Ventes effectuées</h1>
          <div className="flex gap-4 items-center">
            <Select value={period} onValueChange={setPeriod}>
              <SelectTrigger className="w-[180px]">
                <SelectValue placeholder="Sélectionner une période" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="day">Aujourd'hui</SelectItem>
                <SelectItem value="week">Cette semaine</SelectItem>
                <SelectItem value="month">Ce mois</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </div>
        
        <Card className="p-6">
          <TransactionTable 
            transactionType="sale" 
            period={period} 
            onRefetch={refetch}
          />
        </Card>
      </div>
    </DashboardLayout>
  );
};

export default Sold;
